import React, { useState, useEffect, Fragment } from "react";
import configurationFile from "config/index";
import "./index.scss";
import Select from "react-select";
import {
	getInstitutionByUniqueCode,
	getInstitutions,
} from "services/institutions";
import { getPublicProducts } from "services/products";
import { getLevels } from "services/levels";
import { getBanks } from "services/banks";
import { getConfigurations } from "services/configurations";
import { formatNumber, validateEmail } from "services/utilities";
import { createOrder, uploadOrderDocument } from "services/orders";
import Loading from "components/loading";
import Modal from "react-bootstrap/Modal";
import StoreLayout from "layouts/storeLayout";
import ReusableModal from "components/reusableModal";
import BanksList from "components/reusable/banksList";
import AdditionalDetails from "components/store/additionalDetails";
const freeDelivery = process.env.REACT_APP_FREE_DELIVERY === "true";
const serverUrl = process.env.REACT_APP_SERVER_URL || "";
const defaultPrice = Number(process.env.REACT_APP_DEFAULT_PRICE || 7000);
const {
	allowedDeliveryMethods,
	allowedPaymentMethodsGuidelines,
	initialAllowedPaymentMethodsGuidelines,
	allowedPaymentMethodsShowBanks,
	allowedPaymentMethodsSelectBanks,
	allowedPaymentMethodsMap,
	defaultAllowedPaymentMethods,
	defaultAllowedDeliveryMethods,
	institutionalAllowedPaymentMethods,
	identificationTypes,
	allowedDeliveryMethodsMap,
	directAllowedPaymentMethods,
	defaultInstitutionDeliveryMessage,
	supportedAddressFirstLine,
	allowedPaymentMethods,
	additionalRequiredDataPaymentMethods,
} = configurationFile;

const getFormInfo = (userData) => {
	if (userData?.name) {
		return {
			email: userData.email,
			identification: userData.identification,
			name: userData.name,
			lastName: userData.lastName,
			phoneNumber: userData.phoneNumber || "",
			institutionalEmail: "",
		};
	} else {
		return {};
	}
};

const getKeyName = (data) => {
	return (data.name + data.lastName).trim();
};

const Store = ({ guardData }) => {
	const isInstitutionalStore =
		window.location.pathname.includes("institutional");
	const [loadingInstitutions, setLoadingInstitutions] = useState(true);
	const [institutions, setInstitutions] = useState([]);
	const [currentInstitution, setCurrentInstitution] = useState();
	const [loadingProducts, setLoadingProducts] = useState(false);
	const [products, setProducts] = useState([]);
	const [levels, setLevels] = useState([]);
	const [loadedProducts, setLoadedProducts] = useState(false);
	const [currentLevel, setCurrentLevel] = useState("");
	const [currentSearch, setCurrentSearch] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [form, setForm] = useState({
		deliveryMethod: allowedDeliveryMethods[0],
		email: "",
		institutionalEmail: "",
		identification: "",
		identificationType: "CC",
		indications: "",
		name: "",
		lastName: "",
		paymentMethod: "",
		phoneNumber: "",
		paymentBank: "",
		additionalDetails: {
			name: "",
			lastName: "",
			identificationType: "TI",
			identification: "",
			level: "",
			email: "",
		},
		selectedHeadquarter: "",
		extraAdditionalDetails: [],
		userType: "",
		...getFormInfo(guardData),
	});
	const [showPrices, setShowPrices] = useState(false);
	const [acceptTerms, setAcceptTerms] = useState(true);
	const [generateEletronicInvoice, setGenerateEletronicInvoice] =
		useState(false);
	const [address, setAddress] = useState({
		type: supportedAddressFirstLine[0].value,
		typeNumber: "",
		firstNumber: "",
		secondNumber: "",
		indications: "",
		city: "",
		department: "",
	});
	const [allowStorePickUp, setAllowStorePickUp] = useState(false);
	const [promotionalProducts, setPromotionalProducts] = useState([]);
	const [currentPromotions, setCurrentPromotions] = useState([]);
	const [showPromotionsList, setShowPromotionsList] = useState(false);
	const [showPromotionsModal, setShowPromotionsModal] = useState(false);
	const [storeConfigurations, setStoreConfigurations] = useState(null);
	const [storeBanks, setStoreBanks] = useState([]);
	const [errorMessageModalContent, setErrorMessageModalContent] = useState("");
	const [currentAllowedPaymentMethods, setCurrentAllowedPaymentMethods] =
		useState(defaultAllowedPaymentMethods);
	const [currentAllowedDeliveryMethods, setCurrentAllowedDeliveryMethods] =
		useState(defaultAllowedDeliveryMethods);
	const [orderDocument, setOrderDocument] = useState(null);
	const [uniqueCode, setUniqueCode] = useState({
		request: false,
		value: "",
		numeric: "",
		text: "",
		waiting: false,
		loading: false,
	});
	const [formErrors, setFormErrors] = useState({
		email: false,
		institutionalEmail: false,
		additionalDetails: false,
	});

	const onChangeHandler = (event) => {
		const currentOrderDocument = event.target.files[0];
		if (currentOrderDocument) {
			if (currentOrderDocument.size > 5242880) {
				alert("El tamaño máximo permitido es de 5 mb");
			} else {
				setOrderDocument(currentOrderDocument);
			}
		}
	};

	const closeErrorMessageModal = () => {
		setErrorMessageModalContent("");
		setShowModal(true);
	};

	const showErrorMessageModal = (errorMessage) => {
		setShowModal(false);
		setErrorMessageModalContent(errorMessage);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		const orderProducts = [];
		let numberOfProducts = 0;
		let requiredStudents = 0;
		products.concat(promotionalProducts).forEach((product) => {
			if (product.added && product.units > 0) {
				orderProducts.push({
					units: product.units,
					product: product._id,
					promotional: product.promotional === true,
				});
				numberOfProducts += product.units;
				if (!product.promotional) {
					requiredStudents += product.units;
				}
			}
		});
		if (orderProducts.length > 0) {
			const promotionQuantity = orderProducts.filter(
				(product) => product.promotional === true
			);
			if (promotionQuantity.length === orderProducts.length) {
				showErrorMessageModal(
					"Debes adquirir un producto institucional para poder acceder a los productos en promoción"
				);
				return;
			}
			if (String(form.identification).length > 11) {
				showErrorMessageModal(
					"La longitud del documento de identificación es inválida"
				);
				return;
			}
			if (!showPromotionsList && promotionalProducts.length > 0) {
				setShowModal(false);
				setShowPromotionsList(true);
				setShowPromotionsModal(true);
				return;
			}

			if (
				isInstitutionalStore &&
				currentInstitution.requestOrderDocument &&
				!orderDocument
			) {
				showErrorMessageModal("Se debe ingresar la orden de compra");
				return;
			}

			let selectedHeadquarter = "";
			if (
				!isInstitutionalStore &&
				currentInstitution.requestFavoriteHeadquarter
			) {
				if (form.selectedHeadquarter) {
					selectedHeadquarter = form.selectedHeadquarter;
				} else {
					showErrorMessageModal(
						"Se debe seleccionar la sede para presentar el examen"
					);
					return;
				}
			}

			setLoadingSubmit(true);
			let currentAddress = "";
			if (address.typeNumber) {
				currentAddress = `${address.type} ${address.typeNumber} # ${address.firstNumber} - ${address.secondNumber}`;
			}

			let paymentBank = undefined;
			let paymentBankId = undefined;

			if (
				(guardData.cajero || guardData.gestion) &&
				allowedPaymentMethodsSelectBanks[form.paymentMethod] &&
				form.paymentBank
			) {
				const selectedBank = storeBanks.find(
					(bank) => bank._id === form.paymentBank
				);
				if (selectedBank) {
					const { name, accountNumber, accountType, _id, code } = selectedBank;
					paymentBank = `${name} (${accountNumber || code} - ${
						accountType || "n/a"
					})`;
					paymentBankId = _id;
				}
			}

			let additionalDetails = null;
			let extraAdditionalDetails = [];
			if (
				currentInstitution.requestAdditionalDetails ||
				currentInstitution.requestAdditionalDetailsLevel
			) {
				const emails = new Set([form.email, form.additionalDetails.email]);
				const names = new Set([
					getKeyName(form),
					getKeyName(form.additionalDetails),
				]);
				const identifications = new Set([
					form.identification,
					form.additionalDetails.identification,
				]);

				if (emails.size < 2 || names.size < 2 || identifications.size < 2) {
					showErrorMessageModal(
						"Los datos del acudiente y del estudiante deben ser diferentes"
					);
					setLoadingSubmit(false);
					return;
				}

				const currentStudents = 1 + (form.extraAdditionalDetails?.length || 0);
				if (currentStudents < requiredStudents) {
					showErrorMessageModal(
						"Existen menos estudiantes que productos asociados a la orden. Se deben asociar al menos " +
							requiredStudents +
							" estudiantes diferentes"
					);
					setLoadingSubmit(false);
					return;
				}

				additionalDetails = { ...form.additionalDetails };
				if (form.extraAdditionalDetails?.length) {
					if (currentStudents > numberOfProducts) {
						showErrorMessageModal(
							"Existen más estudiantes que productos asociados a la orden. Se pueden asociar máximo " +
								numberOfProducts +
								" estudiantes"
						);
						setLoadingSubmit(false);
						return;
					}

					form.extraAdditionalDetails.forEach((additional) => {
						if (
							additional.name &&
							additional.lastName &&
							additional.identification &&
							additional.email
						) {
							emails.add(additional.email);
							names.add(getKeyName(additional));
							identifications.add(additional.identification);
							extraAdditionalDetails.push(additional);
						}
					});

					const totalDataItems = 2 + form.extraAdditionalDetails.length;
					if (
						emails.size < totalDataItems ||
						names.size < totalDataItems ||
						identifications.size < totalDataItems
					) {
						showErrorMessageModal(
							"Los datos del acudiente y de los estudiante deben ser diferentes"
						);
						setLoadingSubmit(false);
						return;
					}
				}
			}

			const orderData = {
				orderProducts,
				client: {
					...form,
					city: address.city,
					department: address.department,
					indications: address.indications,
					address: currentAddress,
					lastName:
						form.identificationType === identificationTypes[2]
							? " "
							: form.lastName,
				},
				paymentBank,
				paymentBankId,
				deliveryMethod: form.deliveryMethod,
				paymentMethod: form.paymentMethod,
				generateEletronicInvoice,
				additionalDetails,
				extraAdditionalDetails,
				selectedHeadquarter,
				userType: currentInstitution.requestUserTypeSelection
					? form.userType?.name
					: "",
			};

			if (additionalRequiredDataPaymentMethods[form.paymentMethod]) {
				orderData[
					additionalRequiredDataPaymentMethods[form.paymentMethod].name
				] = form[additionalRequiredDataPaymentMethods[form.paymentMethod].name];
			}

			createOrder(orderData, guardData?.sub || "", isInstitutionalStore)
				.then((replaceUrl) => {
					if (
						isInstitutionalStore &&
						currentInstitution.requestOrderDocument &&
						orderDocument
					) {
						const orderId = new URL(replaceUrl).searchParams.get("id");
						const orderDocumentData = new FormData();
						orderDocumentData.append("file", orderDocument);
						uploadOrderDocument(orderId, orderDocumentData)
							.then((res) => {
								window.location.replace(replaceUrl);
							})
							.catch((err) => {
								showErrorMessageModal(err);
								window.location.replace(replaceUrl);
							})
							.finally(() => {
								setLoadingSubmit(false);
							});
					} else {
						window.location.replace(replaceUrl);
					}
				})
				.catch((err) => {
					showErrorMessageModal(err);
					setLoadingSubmit(false);
				});
		}
	};

	const checkFormErrors = () => {
		const currentFormErrors = {
			email: false,
			institutionalEmail: false,
			additionalDetails: false,
		};
		let validEmails = true;
		if (!form.email || !validateEmail(form.email)) {
			validEmails = false;
			currentFormErrors.email = true;
		}
		if (
			currentInstitution.requestInstitutionalEmail &&
			!isInstitutionalStore &&
			(!form.institutionalEmail || !validateEmail(form.institutionalEmail))
		) {
			validEmails = false;
			currentFormErrors.institutionalEmail = true;
		}
		if (currentInstitution.requestAdditionalDetails) {
			if (
				!form.additionalDetails.email ||
				!validateEmail(form.additionalDetails.email)
			) {
				validEmails = false;
				currentFormErrors.additionalDetails = true;
			}
		}
		setFormErrors(currentFormErrors);
		return validEmails;
	};

	const handleDataSubmit = (event) => {
		event.preventDefault();
		if (checkFormErrors()) {
			document.getElementsByClassName("modal")[0].scrollTo(0, 0);
			setShowPrices(true);
		}
	};

	const loadInstitutionProducts = (currentInstitutionData) => {
		const institutionData = currentInstitution || currentInstitutionData;
		const selectedInstitutionId = institutionData?.value;
		const possibleNewCurrentAllowedPaymentMethods =
			guardData.cajero || guardData.gestion
				? allowedPaymentMethods
				: institutionData.allowedPaymentMethods;
		const possibleNewCurrentAllowedDeliveryMethods =
			guardData.cajero || guardData.gestion
				? allowedDeliveryMethods
				: institutionData.allowedDeliveryMethods;
		const newCurrentAllowedPaymentMethods =
			possibleNewCurrentAllowedPaymentMethods?.length
				? possibleNewCurrentAllowedPaymentMethods
				: defaultAllowedPaymentMethods;
		const newCurrentAllowedDeliveryMethods =
			possibleNewCurrentAllowedDeliveryMethods?.length
				? possibleNewCurrentAllowedDeliveryMethods
				: defaultAllowedDeliveryMethods;

		setCurrentAllowedPaymentMethods(newCurrentAllowedPaymentMethods);
		if (!guardData.cajero && !guardData.gestion) {
			const allowDirectSaleIndex = newCurrentAllowedDeliveryMethods.indexOf(
				allowedDeliveryMethods[3]
			);
			if (
				allowDirectSaleIndex !== -1 &&
				storeConfigurations?.allowDirectSale?.value !== "true"
			) {
				newCurrentAllowedDeliveryMethods.splice(allowDirectSaleIndex, 1);
			}
			const allowStorePickUpIndex = newCurrentAllowedDeliveryMethods.indexOf(
				allowedDeliveryMethods[1]
			);
			if (allowStorePickUpIndex !== -1 && !allowStorePickUp) {
				newCurrentAllowedDeliveryMethods.splice(allowStorePickUpIndex, 1);
			}
			const digitalIndex = newCurrentAllowedDeliveryMethods.indexOf(
				allowedDeliveryMethods[2]
			);
			if (digitalIndex !== -1) {
				newCurrentAllowedDeliveryMethods.splice(digitalIndex, 1);
			}
			if (!newCurrentAllowedDeliveryMethods.length) {
				newCurrentAllowedDeliveryMethods.push(allowedDeliveryMethods[0]);
			}
		}
		setCurrentAllowedDeliveryMethods(newCurrentAllowedDeliveryMethods);
		setForm({
			...form,
			paymentMethod: newCurrentAllowedPaymentMethods[0],
			deliveryMethod: newCurrentAllowedDeliveryMethods[0],
		});
		setLoadingProducts(true);
		if (currentInstitutionData) {
			setLoadingInstitutions(false);
		}
		getPublicProducts(
			"",
			selectedInstitutionId,
			true,
			"false",
			isInstitutionalStore,
			true
		)
			.then((responseProducts) => {
				getLevels(selectedInstitutionId)
					.then((responseLevels) => {
						const removedLevels = [];
						const currentLevels = [];
						let currentProducts = [];
						responseLevels.forEach((level) => {
							if (level.hidden) {
								removedLevels.push(level._id);
							} else {
								currentLevels.push(level);
							}
						});
						if (removedLevels.length > 0) {
							responseProducts.forEach((product, index) => {
								if (product.levels.length > 0) {
									product.levels = product.levels.filter(
										(level) => !removedLevels.includes(level._id)
									);
									if (product.levels.length > 0) {
										currentProducts.push(product);
									}
								} else {
									currentProducts.push(product);
								}
							});
						} else {
							currentProducts = responseProducts;
						}
						setProducts(currentProducts);
						setLevels(currentLevels);
					})
					.catch((err) => {
						console.error(err);
						setProducts([]);
						setLevels([]);
					})
					.finally(() => {
						setLoadedProducts(true);
						setLoadingProducts(false);
					});
			})
			.catch((err) => {
				console.error(err);
				setProducts([]);
				setLoadedProducts(true);
				setLevels([]);
				setLoadingProducts(false);
			});
	};

	const changeInstitution = () => {
		setProducts([]);
		setLevels([]);
		setPromotionalProducts(JSON.parse(JSON.stringify(currentPromotions)));
		setCurrentSearch("");
		setCurrentLevel("");
		setAddress({
			type: supportedAddressFirstLine[0].value,
			typeNumber: "",
			firstNumber: "",
			secondNumber: "",
			indications: "",
			city: "",
			department: "",
		});
		setForm({
			deliveryMethod: currentAllowedDeliveryMethods[0],
			email: "",
			institutionalEmail: "",
			identification: "",
			identificationType: "CC",
			name: "",
			lastName: "",
			phoneNumber: "",
			additionalDetails: {
				name: "",
				lastName: "",
				identificationType: "TI",
				identification: "",
				level: "",
			},
			extraAdditionalDetails: [],
			userType: "",
			...getFormInfo(guardData),
		});
		setOrderDocument(null);
		setShowPrices(false);
		setAcceptTerms(false);
		setLoadedProducts(false);
		setLoadingProducts(false);
	};

	const renderProducts = () => {
		let productsToRender = [...products];
		if (currentLevel) {
			productsToRender = productsToRender.filter((product) =>
				product.levels.map((level) => level._id).includes(currentLevel)
			);
		}

		if (currentSearch) {
			const current = currentSearch.toLowerCase();
			productsToRender = productsToRender.filter((product) => {
				for (let index = 0; index < product.isbns.length; index++) {
					if (
						product.isbns[index].name.toLowerCase().includes(current) ||
						String(product.isbns[index].isbn).includes(current)
					) {
						return true;
					}
				}
				return false;
			});
		}

		if (productsToRender.length > 0) {
			return productsToRender.map((product) => renderProduct(product));
		} else {
			return (
				<li className="list-group-item border-primary bg-dark text-white text-center">
					<p className="mb-0">
						No encontramos libros con los filtros que ingresaste
					</p>
				</li>
			);
		}
	};

	const renderPromotionalProducts = () => {
		return promotionalProducts.map((product) => {
			if (
				product.allowedInstitutions?.length &&
				!product.allowedInstitutions.includes(currentInstitution.value)
			) {
				return null;
			}
			return renderProduct(product, true);
		});
	};

	const renderPromotions = () => {
		return promotionalProducts.length > 0 ? (
			<div className="col-lg-11 mx-auto text-left pt-3">
				{!showPromotionsList && (
					<button
						className="btn btn-info btn-sm"
						onClick={() => setShowPromotionsList(true)}
					>
						<em className="fas fa-percentage" />
						&nbsp;Ver promociones
					</button>
				)}
				{showPromotionsList && (
					<ul className="list-group list-group-flush shadow-lg border border-info mt-2">
						<li className="list-group-item border-info bg-info text-white text-left">
							<h5 className="mb-0">Productos en promoción</h5>
						</li>
						{renderPromotionalProducts()}
					</ul>
				)}
			</div>
		) : null;
	};

	const manageProduct = (
		id,
		add,
		increment = true,
		promotion = false,
		value = null
	) => {
		const currentProducts = [...(promotion ? promotionalProducts : products)];
		const productToAdd = currentProducts.find((product) => product._id === id);
		if (add) {
			productToAdd.added = true;
			productToAdd.units = 1;
		} else {
			if (value !== null) {
				if (value === 0) {
					productToAdd.units = 0;
					productToAdd.added = false;
				} else {
					productToAdd.units = value;
				}
			} else {
				if (increment) {
					productToAdd.units++;
				} else {
					if (productToAdd.units - 1 === 0) {
						productToAdd.units = 0;
						productToAdd.added = false;
					} else {
						productToAdd.units--;
					}
				}
			}
		}
		if (promotion) {
			setPromotionalProducts(currentProducts);
		} else {
			setProducts(currentProducts);
		}
	};

	const handleProductUnits = (id, promotion) => (event) => {
		try {
			const inputNumber = Number(event.target.value || 0);
			if (!isNaN(inputNumber) && inputNumber >= 0) {
				manageProduct(id, false, null, promotion, inputNumber);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const renderCartButton = () => {
		let numberOfProducts = 0;
		products.concat(promotionalProducts).forEach((product) => {
			if (product.added) {
				numberOfProducts += product.units;
			}
		});
		return (
			!showModal && (
				<div className="col-lg-5 mx-auto mt-4 pt-1 text-center">
					<button
						className="btn btn-primary w-100 text-white shadow-none"
						onClick={showProductsCart}
					>
						<div className="d-flex align-items-center no-gutters justify-content-center">
							<p className="mb-0 pl-2 pr-2 d-inline-block rounded bg-dark-primary text-left mr-2">
								{numberOfProducts}
							</p>
							<p className="mb-0 font-weight-bold text-09-rem text-center">
								Confirmar
							</p>
						</div>
					</button>
				</div>
			)
		);
	};

	const renderProduct = (product, promotion = false) => {
		return (
			<li
				key={product._id}
				className={`list-group-item border-${
					promotion ? "info" : "primary"
				} bg-dark text-white text-left`}
			>
				<div className="row d-flex align-items-center">
					<div className="col-12">
						{product.name && <p>{product.name}</p>}
						{product.isbns.map((isbn) => (
							<div className="overflow-hidden" key={isbn._id}>
								{isbn.image && (
									<img
										className="mr-2 mb-3 shadow border border-white float-left"
										src={`${serverUrl}${isbn.image}`}
										alt={isbn.name}
										width="60"
										height="80"
									/>
								)}
								<div
									className="overflow-hidden"
									style={{ wordWrap: "break-word" }}
								>
									<p className="mb-0">
										<strong>
											{isbn.name}
											{isbn.type === "Digital" && (
												<span>
													&nbsp;(Digital){" "}
													<em className="fas fa-compact-disc text-info"></em>
												</span>
											)}
											{isbn.type === "Impreso - Digital" && (
												<span>
													&nbsp;(Digital con entrega){" "}
													<em className="fas fa-compact-disc text-info"></em>
												</span>
											)}
										</strong>
									</p>
									<p className="mb-1 text-09-rem">
										<strong>ISBN:</strong> {isbn.isbn}
									</p>
								</div>
							</div>
						))}
					</div>
					{!promotion && (
						<div className="col-12">
							{product.levels.length > 0 && (
								<p className="mb-0 mt-1 text-08-rem">
									<strong className="">
										Nivel{product.levels.length > 1 && "es"}:
									</strong>
									&nbsp;{product.levels.map((level) => level.name).join(", ")}
								</p>
							)}
						</div>
					)}
					{promotion && (
						<div className="col-lg-8">
							<p className="font-weight-bold mb-0">
								<span className="px-1 bg-info">
									{product.discountPercentage}% DCTO
								</span>
								&nbsp;<span className="text-primary">$</span>&nbsp;
								{formatNumber(product.price)}
							</p>
						</div>
					)}
					<div className="col-12 text-right mb-1">
						{!product.added && (
							<button
								className={`w-100-px btn btn-${
									promotion ? "info" : "primary"
								} text-white btn-sm btn-pill shadow-none mt-2`}
								onClick={() =>
									manageProduct(product._id, true, true, promotion)
								}
							>
								Agregar
							</button>
						)}
						{product.added && (
							<div className="w-100-px row bg-white text-dark shadow-lg no-gutters ml-auto mt-2 product-units">
								<div
									className="col-3 text-center pointer"
									onClick={() =>
										manageProduct(product._id, false, false, promotion)
									}
								>
									<em className="fas fa-minus"></em>
								</div>
								<div className="col-6 text-center no-select product-units__container text-dark">
									<input
										type="number"
										className="text-dark"
										disabled={loadingSubmit || !isInstitutionalStore}
										value={product.units}
										onChange={handleProductUnits(product._id, promotion)}
									/>
								</div>
								<div
									className="col-3 text-center pointer"
									onClick={() =>
										(!promotion || (promotion && product.units !== 2)) &&
										manageProduct(product._id, false, true, promotion)
									}
								>
									<em className="fas fa-plus"></em>
								</div>
							</div>
						)}
					</div>
				</div>
			</li>
		);
	};

	const allDigital = () => {
		const selectedProducts = products
			.concat(promotionalProducts)
			.filter((product) => product.added);
		let digital = true;
		for (let index = 0; index < selectedProducts.length; index++) {
			if (
				selectedProducts[index].isbns.find(
					(isbn) => isbn.type === "Impreso" || isbn.type === "Impreso - Digital"
				)
			) {
				return false;
			}
		}
		return digital;
	};

	const getDeliveryPrice = () => {
		if (storeConfigurations?.cities?.value) {
			const department = storeConfigurations.cities.value[address.department];
			if (department) {
				const city = department.cities.find(
					({ name }) => name === address.city
				);
				if (city?.price) {
					return Number(city.price);
				}
			}
		}
		return defaultPrice;
	};

	const renderGenerateEletronicInvoice = (totalPrice) => {
		return (
			<div>
				<hr />
				<p className="mb-0 no-select text-small">
					{storeConfigurations.uvt &&
					totalPrice > storeConfigurations.uvt.value * 5 ? (
						<>
							<em className="text-info pointer fas fa-info-circle"></em>
							&nbsp;Generaremos una factura electrónica asociada a tu pedido
						</>
					) : (
						<>
							<label className="font-weight-bold no-select">
								¿Quieres factura electrónica? {generateEletronicInvoice}
							</label>
							<div className="row">
								<div className="col-md-2 col-3">
									<span
										className="pointer"
										onClick={() =>
											!loadingSubmit && setGenerateEletronicInvoice(true)
										}
									>
										<em
											className={
												"text-primary far " +
												(generateEletronicInvoice
													? "fa-check-circle"
													: "fa-circle")
											}
										></em>
										&nbsp;Sí
									</span>
								</div>
								<div className="col-md-2 col-3">
									<span
										className="pointer"
										onClick={() =>
											!loadingSubmit && setGenerateEletronicInvoice(false)
										}
									>
										<em
											className={
												"text-primary far " +
												(generateEletronicInvoice
													? "fa-circle"
													: "fa-check-circle")
											}
										></em>
										&nbsp;No
									</span>
								</div>
							</div>
						</>
					)}
				</p>
			</div>
		);
	};

	const renderSelectedProducts = () => {
		const selectedProducts = products
			.concat(promotionalProducts)
			.filter((product) => product.added);
		if (selectedProducts.length > 0) {
			const result = [];
			let deliveryPricing = false;
			let totalPrice = 0;
			let numberOfProducts = 0;
			selectedProducts.forEach((product) => {
				result.push(renderSelectedProduct(product));
				if (!deliveryPricing && product.deliveryPricing) {
					deliveryPricing = true;
				}
				totalPrice += product.price * product.units;
				numberOfProducts += product.units;
			});
			if (
				deliveryPricing &&
				!freeDelivery &&
				form.deliveryMethod === allowedDeliveryMethods[0]
			) {
				totalPrice += getDeliveryPrice();
			}
			return (
				<>
					<ul className="list-group list-group-flush">{result}</ul>
					{form.deliveryMethod === allowedDeliveryMethods[0] &&
						deliveryPricing && (
							<>
								<hr className="mt-2" />
								<p className="mb-0">
									<strong>Costo de envío:</strong>&nbsp;
									<span className={freeDelivery ? "text-line-through" : ""}>
										<span className="text-primary">$</span>&nbsp;
										{getDeliveryPrice().toLocaleString("es-co")}
									</span>
									{freeDelivery && " GRATIS"}
								</p>
							</>
						)}
					<hr />
					{storeConfigurations?.informativeMessage?.value && (
						<>
							<p className="mb-0 no-select font-weight-bold">
								<em className="fas fa-info-circle text-info" />
								&nbsp;{storeConfigurations?.informativeMessage?.value}
							</p>
							<hr />
						</>
					)}
					{isInstitutionalStore && currentInstitution.requestOrderDocument && (
						<div className="text-center">
							<p className="mb-2">
								<strong>Orden de compra</strong>
							</p>
							<label className="btn btn-info">
								<em className="fas fa-file-upload" />
								&nbsp;
								{orderDocument
									? orderDocument?.name
									: "Seleccionar archivo"}{" "}
								<input
									type="file"
									accept="image/*,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
									onChange={onChangeHandler}
									hidden
								/>
							</label>
							{!orderDocument && (
								<span className="small d-block mt-2">
									* Aceptamos un archivo pdf, un documento de word o una imagen
									de máximo 5 mb
								</span>
							)}
							{orderDocument && (
								<span className="small d-block mt-2">
									* Haz click en el archivo cargado si necesitas reemplazarlo
								</span>
							)}
							<hr />
						</div>
					)}
					<p className="mb-2">
						<strong>Método de pago</strong>
					</p>
					<select
						name="paymentMethod"
						className="form-control text-dark border-primary pointer mb-2"
						disabled={loadingSubmit}
						value={form.paymentMethod}
						onChange={handleInput}
						required
					>
						{currentAllowedPaymentMethods.map((value) => (
							<option value={value} key={value}>
								{allowedPaymentMethodsMap[value]}
							</option>
						))}
					</select>
					{(guardData.cajero || guardData.gestion) &&
						allowedPaymentMethodsSelectBanks[form.paymentMethod] && (
							<>
								<p className="mb-2">
									<strong>Caja asociada al pago</strong>
								</p>
								<select
									id="paymentBank"
									name="paymentBank"
									className="form-control text-dark border-primary pointer mb-2"
									disabled={loadingSubmit}
									value={form.paymentBank}
									onChange={handleInput}
									required
								>
									<option></option>
									{storeBanks
										.filter((bank) => bank.paymentMethod === form.paymentMethod)
										.map(
											(
												{ name, accountType, accountNumber, code, _id },
												index
											) => (
												<option key={index} value={_id}>
													{name} ({accountNumber || code}
													{accountType ? " - " + accountType : ""})
												</option>
											)
										)}
								</select>
							</>
						)}
					{!!initialAllowedPaymentMethodsGuidelines[form.paymentMethod] && (
						<div
							dangerouslySetInnerHTML={{
								__html:
									initialAllowedPaymentMethodsGuidelines[form.paymentMethod],
							}}
						/>
					)}
					{!!allowedPaymentMethodsShowBanks[form.paymentMethod] &&
						!!storeBanks.length && <BanksList banks={storeBanks} />}
					{!!allowedPaymentMethodsGuidelines[form.paymentMethod] && (
						<div
							dangerouslySetInnerHTML={{
								__html: allowedPaymentMethodsGuidelines[form.paymentMethod],
							}}
						/>
					)}
					{!!additionalRequiredDataPaymentMethods[form.paymentMethod] && (
						<div className="mb-3">
							<label className="font-weight-bold no-select">
								{additionalRequiredDataPaymentMethods[form.paymentMethod].label}
							</label>
							<input
								name={
									additionalRequiredDataPaymentMethods[form.paymentMethod].name
								}
								className="form-control text-dark border-primary"
								type="text"
								disabled={loadingSubmit}
								value={
									form[
										additionalRequiredDataPaymentMethods[form.paymentMethod]
											.name
									]
								}
								onChange={handleInput}
								minLength="2"
								required
							/>
						</div>
					)}
					{renderGenerateEletronicInvoice(totalPrice)}
					<div className="text-center mt-5">
						<button
							type="submit"
							className="btn btn-primary w-100 text-white shadow-none text-center"
							disabled={loadingSubmit}
						>
							{!loadingSubmit && (
								<div className="d-flex align-items-center no-gutters justify-content-between">
									<p className="mb-0 pl-2 pr-2 d-inline-block rounded bg-dark-primary text-left">
										{numberOfProducts}
									</p>
									<p className="mb-0 font-weight-bold text-09-rem text-center">
										{directAllowedPaymentMethods.includes(form.paymentMethod)
											? "Pagar"
											: "Confirmar"}
									</p>
									<p className="mb-0 text-right">
										$ {formatNumber(totalPrice) || "0"}
									</p>
								</div>
							)}
							{loadingSubmit && <em className="fas fa-spin fa-cog fa-lg"></em>}
						</button>
					</div>
				</>
			);
		} else {
			setShowPrices(false);
			setShowModal(false);
			return null;
		}
	};

	const selectUserType = (userType) => {
		const userTypesIds =
			currentInstitution?.userTypes?.map((uT) => uT._id) || [];
		setProducts(
			products.filter(
				(product) =>
					!product.userType ||
					!userTypesIds.includes(product.userType) ||
					userType._id === product.userType
			)
		);
		setForm({
			...form,
			userType,
		});
	};

	const renderSelectedProduct = (product) => {
		return (
			<li
				className="list-group-item border-primary text-dark text-left pl-0 pr-0"
				key={product._id}
			>
				<div className="row d-flex align-items-center">
					<div className="col-12">
						{product.name && <p>{product.name}</p>}
						{product.isbns.map((isbn) => (
							<Fragment key={isbn.isbn}>
								<p className="mb-0">
									<strong>
										{isbn.name}
										{isbn.type === "Digital" && (
											<span>
												&nbsp;(Digital){" "}
												<em className="fas fa-compact-disc text-info"></em>
											</span>
										)}
										{isbn.type === "Impreso - Digital" && (
											<span>
												&nbsp;(Digital con entrega){" "}
												<em className="fas fa-compact-disc text-info"></em>
											</span>
										)}
									</strong>
								</p>
								<p className="mb-1 text-09-rem">
									<strong>ISBN:</strong> {isbn.isbn}
								</p>
							</Fragment>
						))}
					</div>
					{/* <div className="col-12">
                        {product.levels.length > 0 && <p className="mb-0 mt-1 text-08-rem"><strong className="">Nivel{product.levels.length > 1 && 'es'}:</strong>&nbsp;{product.levels.map(level => level.name).join(', ')}</p>}
                    </div> */}
					<div className="col-lg-8">
						<p className="font-weight-bold mb-0">
							<span className="text-primary">$</span>&nbsp;
							{formatNumber(product.price * product.units)}
						</p>
					</div>
					<div className="col-lg-4 text-right">
						{!product.added && (
							<button
								className="w-100-px btn btn-primary text-white btn-sm btn-pill shadow-none mt-2"
								onClick={() =>
									manageProduct(product._id, true, true, product.promotional)
								}
							>
								Agregar
							</button>
						)}
						{product.added && (
							<div className="w-100-px row bg-white text-dark border border-dark no-gutters ml-auto mt-2">
								<div
									className="col-3 text-center pointer"
									onClick={() =>
										!loadingSubmit &&
										manageProduct(
											product._id,
											false,
											false,
											product.promotional
										)
									}
								>
									<em className="fas fa-minus"></em>
								</div>
								<div className="col-6 text-center no-select product-units__container text-dark">
									<input
										type="number"
										className="text-dark"
										disabled={loadingSubmit || !isInstitutionalStore}
										value={product.units}
										onChange={handleProductUnits(
											product._id,
											product.promotional
										)}
									/>
								</div>
								<div
									className="col-3 text-center pointer"
									onClick={() =>
										!loadingSubmit &&
										(!product.promotional ||
											(product.promotional && product.units !== 2)) &&
										manageProduct(product._id, false, true, product.promotional)
									}
								>
									<em className="fas fa-plus"></em>
								</div>
							</div>
						)}
					</div>
				</div>
			</li>
		);
	};

	const showProductsCart = () => {
		const currentSelectedProducts = products.filter((product) => product.added);
		if (currentSelectedProducts.length > 0) {
			setShowModal(true);
		}
	};

	const handleInput = (event) => {
		setForm({
			...form,
			[event.target.name]: event.target.value,
		});
	};

	const handleAddressInput = (event) => {
		const city =
			event.target.name === "department"
				? ""
				: event.target.name === "city"
				? event.target.value
				: address.city;
		setAddress({ ...address, [event.target.name]: event.target.value, city });
	};

	const loadAllowStorePickUp = (configurations) => {
		const pickUpConfig = configurations.find(
			(configuration) => configuration.name === "allowStorePickUp"
		);
		if (pickUpConfig) {
			if (pickUpConfig.type === "Boolean") {
				setAllowStorePickUp(pickUpConfig.value === "true");
			} else if (pickUpConfig.type === "DateRange") {
				const splittedDate = pickUpConfig.value.split(";");
				const currentDate = new Date().getTime().toString();
				if (currentDate < splittedDate[0] || currentDate > splittedDate[1]) {
					setAllowStorePickUp(true);
				}
			}
		}
		const newConfigurations = {};
		configurations.forEach((config) => {
			newConfigurations[config.name] = config;
		});
		if (newConfigurations?.cities) {
			Object.keys(newConfigurations.cities.value).forEach((department) => {
				const departmentCities = newConfigurations.cities.value[
					department
				].cities.filter((city) => city.code);
				newConfigurations.cities.value[department].cities = departmentCities;
			});
		}
		setStoreConfigurations(newConfigurations);
	};

	const loadPromotions = () => {
		getPublicProducts("", "", true, "true")
			.then((promotions) => {
				setCurrentPromotions(promotions);
				setPromotionalProducts(JSON.parse(JSON.stringify(promotions)));
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const setInstitutionAddress = (institutionAddress) => {
		setAddress({ ...address, ...(institutionAddress || {}) });
	};

	const defineInstitutionData = (institution) => {
		return {
			label: institution.name,
			value: institution._id,
			allowedPaymentMethods: institution.allowedPaymentMethods?.length
				? institution.allowedPaymentMethods.filter(
						(allowed) =>
							isInstitutionalStore ||
							!institutionalAllowedPaymentMethods.includes(allowed)
				  )
				: null,
			allowedDeliveryMethods:
				institution.allowedDeliveryMethods || defaultAllowedDeliveryMethods,
			deliveryMethodMessage:
				institution.deliveryMethodMessage || defaultInstitutionDeliveryMessage,
			headquarters: institution.headquarters,
			requestAdditionalDetails: institution.requestAdditionalDetails,
			requestAdditionalDetailsLevel: institution.requestAdditionalDetailsLevel,
			requestOrderDocument: institution.requestOrderDocument,
			requestInstitutionalEmail: institution.requestInstitutionalEmail,
			requestFavoriteHeadquarter: institution.requestFavoriteHeadquarter,
			requestUserTypeSelection: institution.requestUserTypeSelection,
			userTypes: institution.userTypes,
		};
	};

	const setBasicStoreInfo = async (data = []) => {
		setInstitutions(
			data.map((institution) => defineInstitutionData(institution))
		);
		setLoadingInstitutions(false);
		loadPromotions();
	};

	const loadMainConfiguration = async () => {
		try {
			const [configurations, banks] = await Promise.all([
				getConfigurations(isInstitutionalStore),
				getBanks(guardData.cajero || guardData.gestion),
			]);
			setStoreBanks(banks);
			loadAllowStorePickUp(configurations);
		} catch (error) {
			console.log(error);
			setLoadingInstitutions(false);
		}
	};

	const loadInstitutionBasedOnIdentifier = async (numeric, text) => {
		try {
			const numericValue = numeric || uniqueCode.numeric;
			const textValue = text || uniqueCode.text;
			if (
				numericValue &&
				numericValue > 0 &&
				numericValue <= 9999 &&
				textValue &&
				textValue.length === 3
			) {
				const uniqueCodeValue = `${numericValue}-${textValue.toUpperCase()}`;
				setUniqueCode({
					...uniqueCode,
					request: true,
					waiting: false,
					numeric: numericValue,
					text: textValue,
					error: null,
					value: uniqueCodeValue,
					loading: true,
				});
				const institution = await getInstitutionByUniqueCode(uniqueCodeValue);
				if (institution) {
					setUniqueCode({
						...uniqueCode,
						request: true,
						error: null,
						waiting: false,
					});
					const institutionData = defineInstitutionData(institution);
					setInstitutions([institutionData]);
					setCurrentInstitution(institutionData);
					loadPromotions();
					loadInstitutionProducts(institutionData);
				}
			} else {
				setUniqueCode({
					...uniqueCode,
					request: true,
					waiting: true,
					text: "",
					numeric: "",
					value: "",
					error: `El identificador ${numericValue}-${textValue.toUpperCase()} no es válido`,
					loading: false,
				});
			}
		} catch (error) {
			setUniqueCode({
				...uniqueCode,
				request: true,
				waiting: true,
				text: "",
				numeric: "",
				value: "",
				error: error || "",
				loading: false,
			});
		}
	};

	const addStudentDetails = () => {
		const currentExtraAdditionalDetails = JSON.parse(
			JSON.stringify(form.extraAdditionalDetails)
		);
		currentExtraAdditionalDetails.push({
			name: "",
			lastName: "",
			identificationType: "TI",
			identification: "",
			level: "",
			email: "",
		});
		setForm({ ...form, extraAdditionalDetails: currentExtraAdditionalDetails });
	};

	const removeStudentDetails = (index) => {
		const currentExtraAdditionalDetails = JSON.parse(
			JSON.stringify(form.extraAdditionalDetails)
		);
		currentExtraAdditionalDetails.splice(index, 1);
		setForm({ ...form, extraAdditionalDetails: currentExtraAdditionalDetails });
	};

	const handleAdditionalDetailsInput = (additionalDetailsIndex) => (event) => {
		if (additionalDetailsIndex === -1) {
			const additionalDetails = { ...form.additionalDetails };
			additionalDetails[event.target.name] = event.target.value;
			setForm({
				...form,
				additionalDetails,
			});
		} else {
			const currentExtraAdditionalDetails = JSON.parse(
				JSON.stringify(form.extraAdditionalDetails)
			);
			currentExtraAdditionalDetails[additionalDetailsIndex][event.target.name] =
				event.target.value;
			setForm({
				...form,
				extraAdditionalDetails: currentExtraAdditionalDetails,
			});
		}
	};

	useEffect(() => {
		if (storeConfigurations) {
			if (
				!isInstitutionalStore &&
				storeConfigurations.requestUniqueCode?.value === "true"
			) {
				const uniqueCodeValue = new URL(window.location.href).searchParams.get(
					"uniqueCode"
				);
				if (uniqueCodeValue?.includes("-")) {
					const [numeric, text] = uniqueCodeValue.split("-");
					loadInstitutionBasedOnIdentifier(numeric, text);
				} else {
					setUniqueCode({
						...uniqueCode,
						request: true,
						value: null,
						waiting: true,
					});
				}
			} else {
				getInstitutions(
					!isInstitutionalStore,
					isInstitutionalStore,
					false,
					isInstitutionalStore && guardData.superusuario
				)
					.then(async (data) => {
						setBasicStoreInfo(data);
					})
					.catch((error) => {
						console.error(error);
						setLoadingInstitutions(false);
					});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [storeConfigurations, isInstitutionalStore]);

	useEffect(() => {
		loadMainConfiguration();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<StoreLayout guardData={guardData}>
				{uniqueCode.request && uniqueCode.waiting && (
					<>
						<div className="col-12 text-center">
							<label
								className="text-question text-white mb-3"
								htmlFor="react-select-2-input"
							>
								Ingresa el identificador de tu institución
							</label>
						</div>
						<div className="col-8 col-md-4 mx-auto text-dark">
							<div className="d-flex align-items-center">
								<input
									type="number"
									className="form-control border-primary text-white bg-dark text-center hideNumberControls"
									placeholder="123"
									value={uniqueCode.numeric}
									onChange={(event) => {
										setUniqueCode({
											...uniqueCode,
											numeric:
												event.target.value <= 9999
													? event.target.value
													: uniqueCode.numeric,
										});
									}}
									disabled={uniqueCode.loading}
									min={0}
									required
								/>
								<span className="text-white fa-2x">&nbsp;-&nbsp;</span>
								<input
									type="text"
									className="form-control border-primary text-white bg-dark text-center"
									placeholder="WIS"
									value={uniqueCode.text}
									maxLength={3}
									onChange={(event) => {
										setUniqueCode({
											...uniqueCode,
											text: event.target.value?.toUpperCase(),
										});
									}}
									disabled={uniqueCode.loading}
									required
								/>
							</div>
						</div>
						<div className="col-12 pt-3">
							{uniqueCode.loading ? (
								<Loading />
							) : (
								<button
									disabled={
										!uniqueCode.text ||
										!uniqueCode.numeric ||
										uniqueCode.text?.length < 3
									}
									onClick={() => loadInstitutionBasedOnIdentifier()}
									className="btn btn-primary text-white"
								>
									<em className="fas fa-search"></em>&nbsp;Consultar libros
								</button>
							)}
						</div>
						{uniqueCode.error && (
							<div className="col-12">
								<p className="mt-4 mb-0">
									<em className="fas fa-info-circle text-info" />
									&nbsp;{uniqueCode.error}
								</p>
							</div>
						)}
					</>
				)}
				{(!uniqueCode.request ||
					(uniqueCode.request && !uniqueCode.waiting)) && (
					<>
						{!loadingInstitutions && (
							<>
								<div className="col-lg-6 col-md-10 mx-auto text-dark">
									<label
										className="text-question text-white mb-3"
										htmlFor="react-select-2-input"
									>
										{loadedProducts
											? "Institución"
											: "¿A qué institución perteneces?"}
									</label>
									<Select
										isDisabled={
											loadingProducts || (loadedProducts && products.length > 0)
										}
										options={institutions}
										classNamePrefix="wisdom"
										value={currentInstitution}
										noOptionsMessage={() => "No hay instituciones disponibles"}
										onChange={(value) => setCurrentInstitution(value)}
										placeholder="Busca por nombre"
									></Select>
								</div>
								{!loadingProducts && (
									<div className="col-12 text-center mt-4">
										<>
											{(!loadedProducts ||
												(loadedProducts && products.length === 0)) && (
												<button
													disabled={!currentInstitution}
													onClick={() => loadInstitutionProducts()}
													className="btn btn-primary text-white"
												>
													<em className="fas fa-search"></em>&nbsp;Consultar
													libros
												</button>
											)}
											{loadedProducts &&
												products.length > 0 &&
												!uniqueCode.request && (
													<button
														className="btn btn-sm btn-primary text-white"
														onClick={changeInstitution}
													>
														<em className="fas fa-exchange-alt"></em>
														&nbsp;Modificar institución
													</button>
												)}
											{currentInstitution?.requestUserTypeSelection &&
												form.userType && (
													<>
														<div className="col-lg-6 col-md-10 mx-auto mt-2 mb-2">
															<hr className="bg-primary" />
														</div>
														<div className="col-12">
															<h5 className="text-question text-white mb-3">
																Tipo de usuario
															</h5>
															<p className="mb-0">{form.userType.name}</p>
														</div>
													</>
												)}
										</>
									</div>
								)}
								{loadedProducts && (
									<>
										<div className="col-lg-6 col-md-10 mx-auto mt-2 mb-2">
											<hr className="bg-primary" />
										</div>
										<div className="col-12"></div>
										{products.length === 0 && (
											<div className="col-lg-6 col-md-10 mx-auto">
												<p className="text-center mb-0">
													En este momento no tenemos libros disponibles para tu
													institución. Por favor intenta más adelante.
												</p>
											</div>
										)}
										{products.length > 0 && (
											<>
												{currentInstitution?.requestUserTypeSelection &&
												!form.userType &&
												currentInstitution?.userTypes?.length ? (
													<div className="col-lg-11 mx-auto mb-4 pb-1">
														<fieldset className="row">
															<div className="col-12">
																<legend className="text-question text-white mb-3">
																	Selecciona tu tipo de usuario
																</legend>
															</div>
															{currentInstitution.userTypes?.map(
																(userType, index) => (
																	<div className="col-12 mx-auto">
																		<button
																			className="btn btn-info text-white mt-1 mb-3"
																			onClick={() => selectUserType(userType)}
																		>
																			{userType.name}
																		</button>
																	</div>
																)
															)}
														</fieldset>
													</div>
												) : (
													<>
														{products.length > 1 && (
															<div className="col-lg-11 mx-auto mb-4 pb-1">
																<div className="row">
																	<div className="col-lg-5 col-md-6 mx-auto">
																		<label>Busca por ISBN o nombre</label>
																		<input
																			className="form-control border-primary text-white bg-dark"
																			placeholder="97... o ENGLISH..."
																			onChange={(event) => {
																				setCurrentSearch(event.target.value);
																			}}
																		/>
																	</div>
																	{levels.length > 1 && (
																		<>
																			<div className="col-lg-5 col-md-6 mx-auto">
																				<label>Filtra por nivel</label>
																				<select
																					value={currentLevel}
																					className="form-control border-primary text-white bg-dark pointer"
																					onChange={(event) => {
																						setCurrentLevel(event.target.value);
																					}}
																				>
																					<option></option>
																					{levels.map((level) => (
																						<option
																							value={level._id}
																							key={level._id}
																						>
																							{level.name}
																						</option>
																					))}
																				</select>
																			</div>
																		</>
																	)}
																</div>
															</div>
														)}
														<div className="col-lg-11 mx-auto">
															<ul className="list-group list-group-flush shadow-lg border border-primary">
																{renderProducts()}
															</ul>
														</div>
														{renderPromotions()}
														{renderCartButton()}
													</>
												)}
											</>
										)}
									</>
								)}
							</>
						)}
						{(loadingInstitutions || loadingProducts) && (
							<div className="col-12 mt-3 mb-3">
								<Loading />
							</div>
						)}
					</>
				)}
			</StoreLayout>
			<Modal
				show={showPromotionsModal}
				onHide={() => {
					setShowPromotionsModal(false);
					setShowModal(true);
				}}
				backdrop="static"
				size="lg"
			>
				<Modal.Header
					closeButton={true}
					className="d-flex align-items-center bg-dark text-white"
				>
					<Modal.Title>¡Aprovecha nuestras promociones!</Modal.Title>
				</Modal.Header>
				<Modal.Body className="bg-dark pt-0">
					<div className="row">
						{renderPromotions()}
						<div className="col-12 text-center mt-4">
							<button
								className="btn btn-success"
								onClick={() => {
									setShowPromotionsModal(false);
									setShowModal(true);
								}}
							>
								Continuar
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			<Modal
				show={showModal}
				onHide={() => {
					setShowModal(false);
					setShowPrices(false);
				}}
				backdrop="static"
				size="lg"
			>
				<Modal.Header
					closeButton={!loadingSubmit}
					className="d-flex align-items-center"
				>
					<Modal.Title>Confirmar compra</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{showModal && (
						<>
							{!showPrices && (
								<form onSubmit={handleDataSubmit}>
									<div className="row">
										<div className="col-12">
											<h5 className="mb-2">
												<strong>
													Datos de contacto
													{currentInstitution?.requestAdditionalDetails
														? " | Información acudiente"
														: ""}
												</strong>
											</h5>
										</div>
										<div className="col-md-6 mb-3">
											<label className="font-weight-bold no-select">
												Número de identificación
											</label>
											<div className="input-group text-dark">
												<div className="input-group-prepend">
													<select
														id="identificationType"
														name="identificationType"
														className="form-control border-primary pointer"
														value={form.identificationType}
														onChange={handleInput}
													>
														{identificationTypes.map((identificationType) => (
															<option
																className="pointer"
																key={identificationType}
															>
																{identificationType}
															</option>
														))}
													</select>
												</div>
												<input
													name="identification"
													className="form-control border-primary"
													type="number"
													disabled={loadingSubmit}
													value={form.identification}
													onChange={handleInput}
													min="0"
													required
												/>
											</div>
										</div>
										<div className="col-12"></div>
										<div className="col-md-6 mb-3">
											<label className="font-weight-bold no-select">
												Nombre
												{form.identificationType === identificationTypes[2]
													? ""
													: "s"}
											</label>
											<input
												name="name"
												className="form-control text-dark border-primary"
												type="text"
												disabled={loadingSubmit}
												value={form.name}
												onChange={handleInput}
												minLength="2"
												required
											/>
										</div>
										<div
											className={`col-md-6 mb-3 ${
												form.identificationType === identificationTypes[2]
													? "d-none"
													: ""
											}`}
										>
											<label className="font-weight-bold no-select">
												Apellidos
											</label>
											<input
												name="lastName"
												className="form-control text-dark border-primary"
												type="text"
												disabled={loadingSubmit}
												value={form.lastName}
												onChange={handleInput}
												minLength="2"
												maxLength="100"
											/>
										</div>

										<div className="col-12"></div>
										<div className="col-md-6 mb-3">
											<label className="font-weight-bold no-select">
												Correo electrónico{" "}
												{!isInstitutionalStore &&
												currentInstitution?.requestInstitutionalEmail
													? "personal"
													: ""}
											</label>
											<input
												name="email"
												className={`form-control text-dark ${
													formErrors.email ? "border-danger" : "border-primary"
												}`}
												type="email"
												disabled={loadingSubmit}
												value={form.email}
												onChange={handleInput}
												minLength="2"
												maxLength="320"
												required
											/>
											{formErrors.email && (
												<p className="text-danger text-small mb-1">
													** Por favor verifica el correo ingresado
												</p>
											)}
											<p className="small mb-0">
												* Te enviaremos los datos de tu compra a este correo
											</p>
										</div>
										<div className="col-md-6 mb-3">
											<label className="font-weight-bold no-select">
												Télefono de contacto
											</label>
											<input
												name="phoneNumber"
												className="form-control text-dark border-primary"
												type="number"
												disabled={loadingSubmit}
												value={form.phoneNumber}
												onChange={handleInput}
												min="0"
												required
											/>
										</div>
										{!isInstitutionalStore && (
											<>
												{currentInstitution.requestInstitutionalEmail && (
													<div className="col-md-6 mb-3">
														<label className="font-weight-bold no-select">
															Correo electrónico institucional
														</label>
														<input
															name="institutionalEmail"
															className={`form-control text-dark ${
																formErrors.institutionalEmail
																	? "border-danger"
																	: "border-primary"
															}`}
															type="email"
															disabled={loadingSubmit}
															value={form.institutionalEmail}
															onChange={handleInput}
															minLength="2"
															maxLength="320"
															required
														/>
														{formErrors.institutionalEmail && (
															<p className="text-danger text-small mb-0">
																** Por favor verifica el correo ingresado
															</p>
														)}
													</div>
												)}
												{currentInstitution.requestFavoriteHeadquarter && (
													<div className="col-12 mb-3">
														<label className="font-weight-bold no-select">
															Selecciona en que sede deseas presentar el examen
														</label>
														<select
															className="form-control text-dark border-primary pointer"
															name="selectedHeadquarter"
															value={form.selectedHeadquarter}
															onChange={handleInput}
															required
														>
															<option></option>
															{currentInstitution.headquarters?.map(
																(headquarter) => (
																	<option
																		value={`${headquarter.alias}: ${
																			headquarter.type
																		} ${headquarter.typeNumber} # ${
																			headquarter.firstNumber
																		} - ${headquarter.secondNumber}, ${
																			headquarter.city
																		}, ${headquarter.department}${
																			headquarter.indications
																				? " / " + headquarter.indications
																				: ""
																		}`}
																	>
																		{headquarter.alias}
																	</option>
																)
															)}
														</select>
														{form.selectedHeadquarter && (
															<p className="mt-2 mb-0">
																<small>
																	<i className="fas fa-map-marker text-primary"></i>
																	&nbsp;{form.selectedHeadquarter}
																</small>
															</p>
														)}
													</div>
												)}
											</>
										)}
										{(currentInstitution.requestAdditionalDetails ||
											currentInstitution.requestAdditionalDetailsLevel) && (
											<>
												<div className="col-12">
													<hr className="mt-1" />
												</div>
												<div className="col-12">
													<h5 className="mb-2">
														<strong>Datos del estudiante</strong>
													</h5>
												</div>
											</>
										)}
										{currentInstitution.requestAdditionalDetails && (
											<>
												<AdditionalDetails
													index={-1}
													extraAdditionalDetails={form.additionalDetails}
													handleAdditionalDetailsInput={
														handleAdditionalDetailsInput
													}
													requestLevel={
														currentInstitution.requestAdditionalDetailsLevel
													}
													loadingSubmit={loadingSubmit}
													emailError={formErrors.additionalDetails}
												/>
												{form.extraAdditionalDetails?.map(
													(additionalStudent, index) => (
														<AdditionalDetails
															index={index}
															key={"additional" + index}
															extraAdditionalDetails={additionalStudent}
															handleAdditionalDetailsInput={
																handleAdditionalDetailsInput
															}
															removeAdditionalDetails={removeStudentDetails}
															requestLevel={
																currentInstitution.requestAdditionalDetailsLevel
															}
															loadingSubmit={loadingSubmit}
															emailError={
																formErrors?.extraAdditionalDetails?.[index]
															}
														/>
													)
												)}
												<div className="col-12">
													<button
														type="button"
														onClick={addStudentDetails}
														className="btn btn-sm btn-pill btn-info my-1 mr-2 mb-3"
													>
														<em className="fas fa-plus" />
														&nbsp;Añadir estudiante
													</button>
												</div>
											</>
										)}
										{!allDigital() && (
											<>
												<>
													<div className="col-12">
														<hr className="mt-1" />
													</div>
													<div className="col-12">
														<h5 className="mb-2">
															<strong>Tipo de entrega</strong>
														</h5>
													</div>
													<div className="col-md-6 mb-3">
														{currentAllowedDeliveryMethods.length > 1 ? (
															<select
																name="deliveryMethod"
																className="form-control text-dark border-primary pointer"
																disabled={loadingSubmit}
																value={form.deliveryMethod}
																onChange={handleInput}
																required
															>
																{currentAllowedDeliveryMethods.map(
																	(allowedDeliveryMethod) => (
																		<option
																			value={allowedDeliveryMethod}
																			key={allowedDeliveryMethod}
																		>
																			{
																				allowedDeliveryMethodsMap[
																					allowedDeliveryMethod
																				]
																			}
																		</option>
																	)
																)}
															</select>
														) : (
															<p className="mb-0">
																{allowedDeliveryMethodsMap[form.deliveryMethod]}
															</p>
														)}
													</div>
												</>
												{form.deliveryMethod === allowedDeliveryMethods[1] && (
													<div className="col-12">
														<p>
															<em className="fas text-info fa-caret-right" />
															&nbsp;Si compra en Bogotá, recoge tu pedido en la
															Librería Wisdom – Cra 49 No. 95-54, Barrio La
															Castellana o si compra en la Sede Cali, Recoge tu
															pedido en la Librería Wisdom – Cra 85 No. 13B 70,
															Barrio El Ingenio. Los horarios en ambas sedes son
															de lunes a viernes de 8 am a 4:30 pm y sábados de
															8 am a 12 pm - sin ningún costo adicional. Te
															notificaremos por correo cuando tu pedido esté
															listo para ser recogido
														</p>
													</div>
												)}
												{form.deliveryMethod === allowedDeliveryMethods[3] && (
													<div className="col-12">
														<p>
															<em className="fas text-info fa-caret-right" />
															&nbsp;Tu pedido será entregado directamente por un
															representante de Wisdom una vez el pago del mismo
															haya sido aprobado. Ten en cuenta que esto solo
															aplica si te encuentras en un punto de entrega
															autorizado
														</p>
													</div>
												)}
												{form.deliveryMethod === allowedDeliveryMethods[4] && (
													<div className="col-12">
														<p
															dangerouslySetInnerHTML={{
																__html:
																	currentInstitution?.deliveryMethodMessage,
															}}
														></p>
													</div>
												)}
												{form.deliveryMethod === allowedDeliveryMethods[0] && (
													<>
														<div className="col-12">
															<hr className="mt-1" />
														</div>
														<div className="col-12">
															<h5 className="mb-2">
																<strong>Datos de envío</strong>
															</h5>
														</div>
														{isInstitutionalStore &&
														!!currentInstitution?.headquarters?.length ? (
															<div className="col-12">
																<hr className="my-1" />
																{currentInstitution?.headquarters?.map(
																	(headquarter) => (
																		<button
																			type="button"
																			className="btn btn-sm btn-pill btn-outline-primary my-1 mr-2"
																			onClick={() =>
																				setInstitutionAddress(headquarter)
																			}
																		>
																			{headquarter.alias}
																		</button>
																	)
																)}
																<hr className="mt-1 mb-3" />
															</div>
														) : null}
														<div className="col-md-6 mb-3">
															<label className="font-weight-bold no-select">
																Departamento
															</label>
															<select
																name="department"
																className="form-control text-dark border-primary pointer"
																disabled={loadingSubmit}
																value={address.department}
																onChange={handleAddressInput}
																required
															>
																<option></option>
																{Object.keys(
																	storeConfigurations?.cities?.value || {}
																).map((department) => (
																	<option value={department} key={department}>
																		{department}
																	</option>
																))}
															</select>
														</div>
														<div className="col-md-6 mb-3">
															<label className="font-weight-bold no-select">
																Ciudad
															</label>
															<select
																name="city"
																className="form-control text-dark border-primary pointer"
																disabled={loadingSubmit || !address.department}
																value={address.city}
																onChange={handleAddressInput}
																required
															>
																<option></option>
																{address.department &&
																	storeConfigurations?.cities?.value?.[
																		address.department
																	]?.cities.map((city) => (
																		<option value={city.name} key={city.name}>
																			{city.name}
																		</option>
																	))}
															</select>
														</div>
														<div className="col-12 mb-3">
															<label className="font-weight-bold no-select">
																Dirección
															</label>
															<div className="input-group">
																<select
																	name="type"
																	className="form-control text-dark border-primary pointer"
																	disabled={loadingSubmit}
																	value={address.type}
																	onChange={handleAddressInput}
																	required
																>
																	{supportedAddressFirstLine.map(
																		({ value, text }) => (
																			<option key={value} value={value}>
																				{text}
																			</option>
																		)
																	)}
																</select>
																<input
																	name="typeNumber"
																	placeholder="49"
																	className="form-control text-dark border-primary px-1 text-center"
																	type="text"
																	disabled={loadingSubmit}
																	value={address.typeNumber}
																	onChange={handleAddressInput}
																	required
																/>
																<div className="input-group-append border-primary">
																	<span className="input-group-text border-primary px-1">
																		#
																	</span>
																</div>
																<input
																	name="firstNumber"
																	placeholder="95"
																	className="form-control text-dark border-primary px-1 text-center"
																	type="text"
																	disabled={loadingSubmit}
																	value={address.firstNumber}
																	onChange={handleAddressInput}
																	required
																/>
																<div className="input-group-append border-primary">
																	<span className="input-group-text border-primary px-1">
																		-
																	</span>
																</div>
																<input
																	name="secondNumber"
																	placeholder="54"
																	className="form-control text-dark border-primary px-1 text-center"
																	type="text"
																	disabled={loadingSubmit}
																	value={address.secondNumber}
																	onChange={handleAddressInput}
																	required
																/>
															</div>
														</div>
														{form.deliveryMethod ===
															allowedDeliveryMethods[0] && (
															<div className="col-12 mb-3">
																<label className="font-weight-bold no-select">
																	Indicaciones adicionales
																</label>
																<textarea
																	name="indications"
																	placeholder="Casa / Barrio / Edificio / Apartamento"
																	className="form-control text-dark border-primary"
																	type="text"
																	disabled={loadingSubmit}
																	value={address.indications}
																	onChange={handleAddressInput}
																/>
															</div>
														)}
													</>
												)}
											</>
										)}
										<div className="col-12">
											<hr className="mt-1" />
										</div>
										<div className="col-12 mb-3">
											<p className="mb-0 no-select">
												<em
													onClick={() => setAcceptTerms(!acceptTerms)}
													className={
														"text-info pointer " +
														(acceptTerms
															? "fas fa-check-square"
															: "far fa-square")
													}
												></em>
												&nbsp;He leído y acepto los{" "}
												<a
													className="text-info"
													href="https://store.wisdom.net.co/pdf/CO-FO-01TerminosCondicionesYTDPStoreV3.pdf"
													target="_blank"
													rel="noopener noreferrer"
												>
													términos, condiciones y tratamiento de datos
													personales
												</a>
											</p>
										</div>
										{storeConfigurations?.informativeMessage?.value && (
											<>
												<div className="col-12">
													<hr className="mt-0" />
												</div>
												<div className="col-12 mb-3">
													<p className="mb-0 no-select font-weight-bold">
														<em className="fas fa-info-circle text-info" />
														&nbsp;
														{storeConfigurations?.informativeMessage?.value}
													</p>
												</div>
											</>
										)}
										{(guardData?.cajero || guardData?.gestion) &&
										!allowStorePickUp ? null : (
											<div className="col-12 text-center">
												<button
													disabled={!acceptTerms}
													type="submit"
													className="btn btn-primary text-white shadow-none text-center"
												>
													Siguiente
													<em className="ml-2 fas fa-chevron-right"></em>
												</button>
											</div>
										)}
									</div>
								</form>
							)}
							{showPrices && (
								<form onSubmit={handleSubmit}>
									<div className="row">
										<div className="col-12 text-left">
											<button
												id="backButton"
												type="button"
												onClick={() => {
													setShowPrices(false);
												}}
												disabled={loadingSubmit}
												className="p-0 small bg-white border-0 mb-3"
											>
												<em className="fas fa-chevron-left"></em> Regresar
											</button>
										</div>
										<div className="col-12">
											<h5 className="mb-2">
												<strong>Institución</strong>
											</h5>
											<p className="mb-0">{currentInstitution.label}</p>
										</div>
										<div className="col-12">
											<hr />
										</div>
										<div className="col-12">
											<h5 className="mb-0">
												<strong>Libros seleccionados</strong>
											</h5>
										</div>
										<div className="col-12">{renderSelectedProducts()}</div>
									</div>
								</form>
							)}
						</>
					)}
				</Modal.Body>
			</Modal>
			<ReusableModal
				show={!!errorMessageModalContent}
				errorMessage={errorMessageModalContent}
				modalTitle="Error creando el pedido"
				close={closeErrorMessageModal}
			/>
		</>
	);
};

export default Store;
